import { render } from "./PartnerSkuProductDetail.vue?vue&type=template&id=4fb910a6&scoped=true"
import script from "./PartnerSkuProductDetail.vue?vue&type=script&lang=js"
export * from "./PartnerSkuProductDetail.vue?vue&type=script&lang=js"

import "./PartnerSkuProductDetail.vue?vue&type=style&index=0&id=4fb910a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb910a6"]])

export default __exports__